import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

import Home from './components/home';
import Aboutus from './components/aboutus';
import Services from './components/services';
import ContactUs from './components/contactus';
import ServiceType from './components/servicetype';

function App() {
  return (
   <>
    <Router>
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/about' element={<Aboutus/>}/>
        <Route path='/services' element={<Services/>}/>
        <Route path='/contactus' element={<ContactUs/>}/>
        <Route path='/service/:serviceKey' element={<ServiceType/>}/>
        
      </Routes>
    </Router>
      
   </>
  );
}

export default App;
